export default __webpack_public_path__ + "static/media/change.3079d705.svg";